import React from "react";
import styled from "styled-components";
import {
  getPriceByBillingType,
  PriceTermSettings,
  ProductAttributeInputModel,
  RecurrencePriceSettings,
} from "../models";
import { ItemBillingType } from "../enums";
import {
  CustomLabel,
  FlexContainer,
  UtilityMethods,
} from "@mindmemobile/mm-shared-global";
import { AccountSettingsStore } from "../store";

type IProps = {
  terms: PriceTermSettings;
  recurrence: RecurrencePriceSettings;
  billingType: keyof typeof ItemBillingType;
  itemType: string;
  hasVariants: boolean;
  variants: ProductAttributeInputModel;
  variantIndex?: number; //selected variant index
  quantity: number;
  className?: string;
  priceId: string;
};

export const AmountRow = styled(FlexContainer)`
  flex-wrap: wrap;
`;

const PriceDescriptionRow: React.FC<IProps> = ({
  terms,
  recurrence,
  billingType,
  itemType,
  hasVariants,
  variants,
  variantIndex,
  quantity,
  className,
  priceId,
}) => {
  const priceDescription = getPriceByBillingType(
    itemType,
    hasVariants,
    variants,
    priceId,
    billingType,
    terms,
    recurrence,
    quantity,
    variantIndex
  );

  const hideBillingFrequencey = itemType === "Product";

  if (!priceDescription) return null;

  switch (billingType) {
    case "Recurring":
      return (
        <AmountRow alignItems="center" className={className}>
          {(recurrence?.standardPricing?.setUpFee && (
            <CustomLabel>
              $
              {AccountSettingsStore.formatAmount(
                parseFloat(
                  recurrence?.standardPricing?.setUpFee?.toString() || "0"
                ),
                true
              )}{" "}
              <span className="charcoal-label"> SETUP </span> +{" "}
            </CustomLabel>
          )) ||
            null}
          <CustomLabel>
            &nbsp;{priceDescription.priceWithDiscount || priceDescription.price}{" "}
            <span className="charcoal-label">USD / EVERY</span>{" "}
            {recurrence.billingIntervalCount}{" "}
            <span className="charcoal-label">
              {recurrence.billingInterval +
                `${recurrence.billingIntervalCount > 1 ? "s" : ""}`}
            </span>
          </CustomLabel>
        </AmountRow>
      );
    case "Term":
      return (
        <AmountRow spacing={10} className={className}>
          <CustomLabel>
            {hideBillingFrequencey ? (
              ""
            ) : (
              <>
                {terms.termIntervalCount}
                <span className="charcoal-label">
                  {" "}
                  {terms.billingInterval} |
                </span>
              </>
            )}
            ${priceDescription.priceWithDiscount || priceDescription.price}{" "}
            <span className="charcoal-label">USD</span>
          </CustomLabel>
        </AmountRow>
      );

    case "TermPlusRecurring":
      return (
        <AmountRow spacing={10} className={className}>
          <div className="term-recurring">
            {priceDescription.price && (
              <>
                {terms.termIntervalCount}{" "}
                <span className="charcoal-label">
                  {terms.billingInterval} |{" "}
                </span>
                {priceDescription.priceWithDiscount || priceDescription.price}
                <span className="charcoal-label"> USD</span> +{" "}
              </>
            )}
            <CustomLabel fontSize="14px">
              {priceDescription.priceWithDiscount || priceDescription.price}{" "}
              <span className="charcoal-label">/ EVERY </span>
            </CustomLabel>
            <CustomLabel fontSize="14px">
              {" "}
              &nbsp;{recurrence.billingIntervalCount}
            </CustomLabel>
            <span className="charcoal-label">
              {" "}
              {recurrence.billingInterval +
                `${recurrence.billingIntervalCount > 1 ? "s" : ""}`}{" "}
            </span>
          </div>
        </AmountRow>
      );
    default:
      return null;
  }
};

export default PriceDescriptionRow;
